import React from "react";
import { Row, Col, Checkbox, InputNumber } from "antd";
import "../styles.css";

const spanstyles = {
  marginRight: 8,
};

export const getRetentionSettingsDefaultConfigs = {
  retention_set_retention: false,
  retention_year: undefined,
  retention_month: undefined,
  retention_days: undefined,
  retention_edit_retention: false,
};

function RetentionSettings(props) {
  return (
    <div className="app_config_checkbox_class2">
      <Row>
        <Col xxl={2} xl={3} lg={4} sm={6}>
          <span style={spanstyles}>
            <Checkbox
              onChange={(e) =>
                props.updateValue(
                  e.target.checked,
                  props._id,
                  "retention_set_retention"
                )
              }
              checked={props.config.retention_set_retention}
            />
          </span>
          <span style={spanstyles}>Set Retention</span>
        </Col>
        <Col xxl={4} xl={6} lg={8} md={10} sm={12} style={{ minWidth: 320 }}>
          <span style={spanstyles}>
            <InputNumber
              onChange={(e) =>
                props.updateValue(e, props._id, "retention_year")
              }
              value={props.config.retention_year}
              width={100}
              placeholder="Year"
            />
          </span>
          <span style={spanstyles}>
            <InputNumber
              onChange={(e) =>
                props.updateValue(e, props._id, "retention_month")
              }
              value={props.config.retention_month}
              width={100}
              placeholder="Month"
            />
          </span>
          <span style={spanstyles}>
            <InputNumber
              onChange={(e) =>
                props.updateValue(e, props._id, "retention_days")
              }
              value={props.config.retention_days}
              width={100}
              placeholder="Days"
            />
          </span>
        </Col>
        <Col xxl={2} xl={3} lg={4} sm={6}>
          <span style={spanstyles}>
            <Checkbox
              onChange={(e) =>
                props.updateValue(
                  e.target.checked,
                  props._id,
                  "retention_edit_retention"
                )
              }
              checked={props.config.retention_edit_retention}
            />
          </span>
          <span style={spanstyles}>Edit Retention</span>
        </Col>
      </Row>
    </div>
  );
}

export default React.memo(RetentionSettings);
